import React from 'react';
const MailMarketingSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-mail-marketing" });
MailMarketingSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-mail-marketing sirius-icon-jump-out-mail-marketing-enhance" });
export default MailMarketingSvg;
